import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { Plus, Trash, PencilSimple, FloppyDisk, X, Tag } from "@phosphor-icons/react";
import { toast } from "sonner";

const COLORS = ["#AB0000", "#E11818", "#F8F0D8", "#FFFDDE", "#E1F2E8", "#FFDFD3", "#32D74B", "#1A1A1A"];
const EMPTY = { name: "", color: "" };

export default function Departments() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/departments");
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Informe o nome");
    const payload = { name: form.name.trim(), color: form.color || null };
    try {
      if (editing) {
        await api.put(`/departments/${editing}`, payload);
        toast.success("Departamento atualizado");
      } else {
        await api.post("/departments", payload);
        toast.success("Departamento criado");
      }
      setForm(EMPTY); setEditing(null); load();
    } catch { toast.error("Erro ao salvar"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Remover este departamento? Produtos e pedidos vinculados manterão apenas o histórico de nome.")) return;
    await api.delete(`/departments/${id}`);
    load();
  };

  const startEdit = (d) => {
    setEditing(d.id);
    setForm({ name: d.name, color: d.color || "" });
  };

  return (
    <div data-testid="departments-page" className="space-y-8">
      <header>
        <p className="label-brutal">Catálogo</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black">Departamentos</h1>
        <p className="text-brand-ink2 mt-2">Categorize seus produtos. Serve para analisar o perfil de consumo de cada @arroba.</p>
      </header>

      <form onSubmit={submit} className="card-brutal p-6 grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-4 items-end">
        <div>
          <label className="label-brutal">Nome</label>
          <input data-testid="dept-name-input" className="input-brutal" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Ex: Anéis" />
        </div>
        <div>
          <label className="label-brutal">Cor</label>
          <div className="flex gap-1">
            {COLORS.map((c) => (
              <button
                type="button"
                key={c}
                data-testid={`dept-color-${c}`}
                onClick={() => setForm({ ...form, color: c })}
                className={`w-9 h-11 border-2 border-brand-ink ${form.color === c ? "shadow-brutalSm -translate-y-0.5" : ""}`}
                style={{ background: c }}
                title={c}
              />
            ))}
          </div>
        </div>
        <div className="flex gap-2">
          <button data-testid="save-dept-btn" type="submit" className="btn-pink">
            {editing ? <><FloppyDisk weight="bold" size={16} />Salvar</> : <><Plus weight="bold" size={16} />Adicionar</>}
          </button>
          {editing && (
            <button type="button" onClick={() => { setEditing(null); setForm(EMPTY); }} className="btn-white">
              <X weight="bold" size={16} />
            </button>
          )}
        </div>
      </form>

      {items.length === 0 ? (
        <div className="card-brutal p-10 text-center">
          <Tag weight="bold" size={40} className="mx-auto" />
          <p className="font-heading text-xl font-black mt-3">Nenhum departamento</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {items.map((d) => (
            <div key={d.id} data-testid={`dept-card-${d.id}`} className="card-brutal p-4 flex items-center gap-3">
              <div className="w-8 h-8 border-2 border-brand-ink flex-shrink-0" style={{ background: d.color || "#FFFDDE" }} />
              <span className="font-bold flex-1 truncate">{d.name}</span>
              <button data-testid={`edit-dept-${d.id}`} onClick={() => startEdit(d)} className="p-1.5 border-2 border-brand-ink bg-white hover:bg-brand-yellow">
                <PencilSimple weight="bold" size={12} />
              </button>
              <button data-testid={`delete-dept-${d.id}`} onClick={() => remove(d.id)} className="p-1.5 border-2 border-brand-ink bg-white hover:bg-brand-peach">
                <Trash weight="bold" size={12} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
